<template>
  <master-layout>
    <div
      class="h-full lg:flex-1 pt-[24px] pb-[123px] md:pb-[138px] md:pt-[32px] md:px-[56px] px-[24px]"
    >
      <BackButton class="w-full px-[24px] mb-[16px]" :customBack="back" />

      <!-- Success State -->
      <section v-if="hasClaimed" class="flex flex-col items-center justify-center pt-[80px]">
        <div
          class="w-[64px] h-[64px] bg-[#E8F5E9] rounded-full flex items-center justify-center mb-[24px]"
        >
          <ion-icon :icon="checkmarkCircleOutline" class="text-[2rem] text-[#4CAF50]"></ion-icon>
        </div>
        <h2 class="text-[1.5rem] font-bold leading-[2rem] text-center mb-[8px]">
          {{ photoCount }} {{ photoCount === 1 ? 'photo' : 'photos' }} added!
        </h2>
        <p class="text-[1rem] leading-[1.5rem] text-[#6B6B6B] text-center mb-[40px]">
          Check your PhotoDrop gallery to view and download.
        </p>
        <button
          class="w-full max-w-[320px] h-[48px] bg-[#454BEF] text-white rounded-[12px] text-[1rem] font-semibold"
          @click="goToPhotodrop"
        >
          View Photos
        </button>
        <button
          class="w-full max-w-[320px] h-[48px] text-[#454BEF] rounded-[12px] text-[1rem] font-semibold mt-[12px]"
          @click="resetAndTryAgain"
        >
          Enter Another Code
        </button>
      </section>

      <!-- Code Entry State -->
      <section v-else>
        <h1
          class="text-[1.75rem] leading-[2.25rem] font-bold mb-[8px] sm:text-[2.25rem] sm:leading-[2.75rem]"
        >
          Photobooth
        </h1>
        <p class="text-[1rem] leading-[1.5rem] text-[#6B6B6B] mb-[40px]">
          Enter the 6-digit code shown on the photobooth screen to receive your photos.
        </p>

        <div class="flex justify-center mb-[24px]">
          <v-otp-input
            ref="otpInput"
            input-classes="photobooth-otp-input"
            input-type="number"
            inputmode="numeric"
            separator=" "
            :num-inputs="6"
            :should-auto-focus="true"
            :is-disabled="loading"
            @on-complete="handleCodeComplete"
          />
        </div>

        <div v-if="error" class="text-center mb-[24px]">
          <p class="text-[0.875rem] italic leading-[1.25rem] text-[#EC4E20]">{{ error }}</p>
        </div>

        <Loading v-if="loading" variant="inline" />
      </section>
    </div>
  </master-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { checkmarkCircleOutline } from 'ionicons/icons';
import VOtpInput from 'vue3-otp-input';
import BackButton from '@/components/common/BackButton.vue';
import Loading from '@/components/common/LoadingState.vue';

export default {
  name: 'PhotoboothPage',
  components: {
    VOtpInput,
    BackButton,
    Loading,
  },
  computed: {
    ...mapState('photobooth', ['loading', 'error']),
    ...mapGetters('photobooth', ['hasClaimed', 'photoCount']),
  },
  ionViewWillEnter() {
    this.$store.commit('photobooth/reset');
  },
  created() {
    this.checkmarkCircleOutline = checkmarkCircleOutline;
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    async handleCodeComplete(code) {
      await this.$store.dispatch('photobooth/claimCode', code);
      if (this.error && this.$refs.otpInput) {
        this.$refs.otpInput.clearInput();
      }
    },
    goToPhotodrop() {
      this.$router.push('/photodrop');
    },
    resetAndTryAgain() {
      this.$store.commit('photobooth/reset');
      this.$nextTick(() => {
        if (this.$refs.otpInput) {
          this.$refs.otpInput.clearInput();
        }
      });
    },
  },
};
</script>

<style>
.photobooth-otp-input {
  width: 46px;
  height: 60px;
  border-radius: 10px;
  border: 1px solid #d8dadc;
  display: inline-block;
  text-align: center;
  background: #f6f4f0;
  font-size: 24px;
  font-weight: 700;
  margin: 0 4px;
}

.photobooth-otp-input:focus {
  border: 1.5px solid #454bef;
  outline: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
